(() => {
  const CONFIG = {
    redirectToCart: false,     // set true if you want to go to /cart after adding
    tryOpenCartDrawer: true,   // best-effort for drawer themes
  };

  const log = (...args) => console.debug("[QO Presets]", ...args);

  function decodeHtmlEntities(str) {
    // Converts &quot; etc back into real characters for JSON.parse()
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.documentElement.textContent || "";
  }

  function getPresetObject(btn) {
    const raw = btn.getAttribute("data-preset") || "";
    const decoded = decodeHtmlEntities(raw);

    try {
      return JSON.parse(decoded);
    } catch (e) {
      console.warn("[QO Presets] Could not parse data-preset JSON.", {
        raw,
        decoded,
        error: e,
      });
      return null;
    }
  }

  function normalizeItems(presetObj) {
    const items = (presetObj?.items || [])
      .filter((it) => it && it.variant_id && Number(it.qty) > 0)
      .map((it) => ({
        id: Number(it.variant_id),
        quantity: Number(it.qty),
      }))
      .filter(
        (it) =>
          Number.isFinite(it.id) &&
          Number.isFinite(it.quantity) &&
          it.quantity > 0
      );

    return items;
  }

  async function addItemsToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      let detail = "";
      try {
        detail = JSON.stringify(await res.json());
      } catch {
        try {
          detail = await res.text();
        } catch {
          detail = "(no details)";
        }
      }
      throw new Error(`Cart add failed (${res.status}): ${detail}`);
    }

    return res.json();
  }

  function tryOpenCartDrawer() {
    // Events some themes listen for
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    } catch {}

    // If there's a drawer trigger button, try clicking it
    const btn =
      document.querySelector("[data-cart-drawer-open]") ||
      document.querySelector("button[name='open-cart']") ||
      document.querySelector("cart-drawer-toggle button");

    if (btn && typeof btn.click === "function") btn.click();
  }

  function setBusy(btn, busy) {
    btn.disabled = !!busy;
    btn.setAttribute("aria-busy", busy ? "true" : "false");
    btn.classList.toggle("is-loading", !!busy);
  }

  async function handlePresetClick(btn) {
    const preset = getPresetObject(btn);
    if (!preset) {
      alert("Preset JSON could not be parsed. Check console for details.");
      return;
    }

    const items = normalizeItems(preset);
    if (!items.length) {
      log("Preset had no items with qty > 0.");
      return;
    }

    setBusy(btn, true);

    try {
      await addItemsToCart(items);

      if (CONFIG.redirectToCart) {
        window.location.href = "/cart";
        return;
      }

      if (CONFIG.tryOpenCartDrawer) {
        tryOpenCartDrawer();
      }
    } catch (err) {
      console.error(err);
      alert("Could not add preset to cart. Check console for details.");
    } finally {
      setBusy(btn, false);
    }
  }

  function initContainer(container) {
    container.querySelectorAll("[data-preset]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        handlePresetClick(btn);
      });
    });

    const clearBtn = container.querySelector("[data-preset-clear]");
    if (clearBtn) {
      clearBtn.addEventListener("click", (e) => {
        e.preventDefault();
        // UI-only clear (doesn't modify cart)
        document
          .querySelectorAll(
            'input[name^="updates["], input[type="number"], input.quantity__input'
          )
          .forEach((input) => {
            input.value = "0";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-quick-order-presets]").forEach(initContainer);
  });
})();
